/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ leftChain: NonNullable<unknown>, rightChain: NonNullable<unknown> }} Chain_Page_Compare_Stake_Or_Hashrate_Different_No_BothInputs */



/**
* | output |
* | --- |
* | "{leftChain} and {rightChain} have no data" |
*
* @param {Chain_Page_Compare_Stake_Or_Hashrate_Different_No_BothInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_stake_or_hashrate_different_no_both = /** @type {((inputs: Chain_Page_Compare_Stake_Or_Hashrate_Different_No_BothInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_Stake_Or_Hashrate_Different_No_BothInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`${i?.leftChain} and ${i?.rightChain} have no data`)
});